module.exports = __webpack_public_path__ + "img/holiday-inn-san-francisco-fishermans-wharf-holiday-inn-fishermans-wharf-pool.4bca98a1.jpg";